import AppInput from "@src/components/AppInput";
import { UIButton } from "@src/components/UIButton";
import UIModal from "@src/components/UIModal/UIModal";
import { useNotification } from "@src/context/NotificationContext";
import {
  useUpdateFeelingTag,
  useUpdateGenreTag,
} from "@src/queries/tagQueries";
import { useAppDispatch, useAppSelector } from "@src/redux/hooks";
import {
  setRefetchTagsByTagType,
  resetUpdateTagState,
} from "@src/redux/slices/tagFactorySlice";
import { RootState } from "@src/redux/store";
import { IPlaylistRecord } from "@src/types/playlist";
import { ITagType } from "@src/types/tags";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

interface UpdateTagModalProps {
  closeModal: () => void;
  isOpen: boolean;
  openModal: () => void;
  toggleModal: () => void;
  onConfirm: (data: any) => void;
  data?: IPlaylistRecord;
  tagType?: ITagType;
}

const UpdateTagModal: React.FC<UpdateTagModalProps> = ({
  closeModal,
  isOpen,
  onConfirm,
}) => {
  const { tagType, tagData } = useAppSelector(
    (state: RootState) => state.tagFactory.updateTagState
  );
  const {
    setValue,
    watch,
    reset,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ title: string }>();
  const dispatch = useAppDispatch();
  const tagMutationMap = {
    genre: useUpdateGenreTag,
    feeling: useUpdateFeelingTag,
  };

  const updateTagMutation =
    (tagType && tagMutationMap[tagType]?.()) || useUpdateGenreTag();

  const { addNotification } = useNotification();
  const onSubmit = async (formData: { title: string }) => {
    if (!tagType || !updateTagMutation || !tagData.documentId)
      return alert("Please provide a tag type");
    onConfirm(formData);
    updateTagMutation.mutateAsync(
      { tagId: tagData.documentId, title: watch("title") },
      {
        onSuccess: () => {
          addNotification("Success updating tag!", "success");
          dispatch(resetUpdateTagState());
          dispatch(setRefetchTagsByTagType(tagType));
          reset();
        },
        onError: () => {
          addNotification("Error updating tag!", "error");
          reset();
        },
      }
    );
  };
  useEffect(() => {
    if (tagData) {
      setValue("title", tagData.title);
    }
  }, [tagData]);
  return (
    <UIModal
      actions={[
        <UIButton key="cancel" onClick={closeModal} variant="outline">
          Cancel
        </UIButton>,
        <UIButton
          type="submit"
          key="update"
          onClick={handleSubmit(onSubmit)}
          variant="primary"
        >
          Update
        </UIButton>,
      ]}
      isOpen={isOpen}
      title={`Update ${tagType} tag`}
      onClose={closeModal}
    >
      <div
        style={{
          width: 300,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            control={control}
            errors={errors}
            label="Title"
            name="title"
            placeholder="Title"
          />
        </form>
      </div>
    </UIModal>
  );
};

export default UpdateTagModal;
